export const DELIVERY_SLOTS = 5;
export const POPSTATION_TIMESLOTS = 6;
